import { render, staticRenderFns } from "./channelSpuTab.vue?vue&type=template&id=3c2cc6bb&"
import script from "./channelSpuTab.vue?vue&type=script&lang=ts&"
export * from "./channelSpuTab.vue?vue&type=script&lang=ts&"
import style0 from "./channelSpuTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports